import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Menu from './Components/Menu';
import Header from './Components/Header';
import { config } from './Components/Config';
import { format } from 'date-fns';

const DetailParticipant = () => {
    const navigate = useNavigate();
    const { id, participantId } = useParams();
    const [participant, setParticipant] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id && participantId) {
            fetchParticipantDetail();
        }
    }, [id, participantId]);

    const fetchParticipantDetail = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${config.EVENT_ENDPOINT}event/${id}/participants/${participantId}`);
            const result = await response.json();

            if (result.success) {
                setParticipant(result.data || {});
            } else {
                console.error("Failed to fetch participant detail");
            }
        } catch (error) {
            console.error("Error fetching participant detail:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Map the fetched API data, fallback to empty string if loading/missing
    const participantData = {
        fullName: participant.name || '',
        email: participant.email || '',
        salutation: participant.gender || '', // using gender as salutation per JSON
        phone: participant.phone || '',
        companyName: participant.company || '',
        industry: participant.industry || '',
        department: participant.department || '',
        position: participant.position || '',
        procurementRole: participant.procurementRole || '',
        source: participant.source || '',
        allowAttend: participant.allowAttend !== null ? (participant.allowAttend ? 'Allowed' : 'Rejected') : 'Pending', // derive status from allowAttend or other field if needed
        attended: participant.attended || '',
        registrationDate: participant.createdAt ? format(new Date(participant.createdAt), 'yyyy-MM-dd HH:mm') : '', // Assuming there's a createdAt not shown in JSON
        attendanceDate: participant.updatedAt ? format(new Date(participant.updatedAt), 'yyyy-MM-dd HH:mm') : '',
        feedbackSend: participant.sendingFeedback?.toString() || '0'
    };

    if (isLoading) {
        return <div className="p-5 text-center">Loading participant detail...</div>;
    }

    return (
        <div id="participant-detail">
            <div className="container-fluid p-0">
                <div className="row g-0 mh-100vh">
                    <div className="col-md-2 border-end">
                        <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
                            <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
                        </div>
                        <hr className="m-0" />
                        <Menu active="event" />
                    </div>
                    <div className="col-md-10 flex-grow-1" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                        <Header />
                        <hr className="m-0" />
                        <div className="main">
                            <div className="p-4">
                                {/* Breadcrumb */}
                                <div className="d-flex align-items-center text-secondary mb-4">
                                    <span className="cursor-pointer hover-text-dark" onClick={() => navigate('/event')} style={{ cursor: 'pointer' }}>Event</span>
                                    <i className="bi bi-chevron-right mx-2 fs-6"></i>
                                    <span className="cursor-pointer hover-text-dark" onClick={() => navigate(`/event/detail/${id || '1'}`)} style={{ cursor: 'pointer' }}>Event Detail</span>
                                    <i className="bi bi-chevron-right mx-2 fs-6"></i>
                                    <span className="text-dark">Participants Detail</span>
                                </div>

                                <h3 className="mb-4 fw-bold">Participants Detail</h3>

                                <div className="bg-white rounded-3 shadow-sm p-4 mb-4">

                                    {/* Personal Information Section */}
                                    <div className="mb-5">
                                        <h5 className="fw-bold mb-4 fs-6">Personal Information</h5>
                                        <div className="row g-4">
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Full Name</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.fullName} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Email</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.email} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Salutation</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.salutation} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Phone (whatsapp)</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.phone} disabled readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Company Information Section */}
                                    <div className="mb-5">
                                        <h5 className="fw-bold mb-4 fs-6">Company Information</h5>
                                        <div className="row g-4">
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Company Name</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.companyName} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Industry</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.industry} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Department</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.department} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Position</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.position} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Procurement Role</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.procurementRole} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Source</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.source} disabled readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    {/* About Events Section */}
                                    <div>
                                        <h5 className="fw-bold mb-4 fs-6">About Events</h5>
                                        <div className="row g-4">
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Status</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.allowAttend ? 'Accepted' : participantData.allowAttend === null ? 'Pending Approval' : 'Declined'} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Attended</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.attended ? 'Present' : participantData.attended === null ? 'Waiting' : 'Absent'} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Registration Date</label>
                                                <input type="text" className="form-control p-2 bg-light" value={participantData.registrationDate} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Attendance Date</label>
                                                <input type="text" className="form-control p-2 bg-light" value={participantData.attendanceDate} disabled readOnly />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label text-secondary mb-2">Feedback Send</label>
                                                <input type="text" className="form-control p-2 bg-white" value={participantData.feedbackSend} disabled readOnly />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailParticipant;


